module.exports = __webpack_public_path__ + "static/img/cqczizhi.d12fd5c4.png";